export default __webpack_public_path__ + "9a378186679c2ff6e8455cae322b151f.png";